const { createSelector } = require('reselect');
const { showSelector } = require('selectors/testTarget/offers/showEddOnBrowseAndSearch/show/showSelector').default;
const { isTestTargetReadySelector } = require('viewModel/selectors/testTarget/isTestTargetReadySelector');

const showEddOnBrowseAndSearchSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

module.exports = { showEddOnBrowseAndSearchSelector };
